import { render, staticRenderFns } from "./season.vue?vue&type=template&id=3b83efd0"
import script from "./season.vue?vue&type=script&lang=js"
export * from "./season.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports